import { render, staticRenderFns } from "./AdminWalletDraft.vue?vue&type=template&id=453e6150&scoped=true&"
import script from "./AdminWalletDraft.vue?vue&type=script&lang=js&"
export * from "./AdminWalletDraft.vue?vue&type=script&lang=js&"
import style0 from "./AdminWalletDraft.vue?vue&type=style&index=0&id=453e6150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e6150",
  null
  
)

export default component.exports